module.exports = __webpack_public_path__ + "img/emoji_01.9b6cf453.png";